import o from"react";const t={progress:0,scrollDirection:0,isActive:!1,scrollStart:0,scrollEnd:0,setAnimationProps:s=>{}},r=o.createContext(t),e=r.Provider;export{e as ScrollLockProvider,r as default};
